// Stable color per seller (used for vendor badge on cards)
export const SELLER_PALETTE = ["#002FA7", "#00873D", "#7E57C2", "#FF7043", "#E0000F", "#FFC000", "#0EA5E9", "#DB2777", "#16A34A", "#F59E0B"];

export const sellerColor = (key) => {
  if (!key) return "#52525B";
  let hash = 0;
  for (let i = 0; i < key.length; i++) hash = ((hash << 5) - hash) + key.charCodeAt(i);
  return SELLER_PALETTE[Math.abs(hash) % SELLER_PALETTE.length];
};

export const STAGES = [
  { v: "lead",      label: "Seguimiento",    color: "#52525B" },
  { v: "contacted", label: "En transacción", color: "#1E88E5" },
  { v: "won",       label: "Ganado",         color: "#00873D" },
  { v: "lost",      label: "Perdido",        color: "#E0000F" },
];

export const PRIORITIES = [
  { v: "",       label: "Sin prioridad", color: "#A1A1AA", short: "—" },
  { v: "low",    label: "Baja",          color: "#16A34A", short: "Baja" },
  { v: "medium", label: "Media",         color: "#F59E0B", short: "Media" },
  { v: "high",   label: "Alta",          color: "#DC2626", short: "Alta" },
];

export const TYPES = [
  { v: "final",       label: "Final",       color: "#52525B" },
  { v: "reseller",    label: "Revendedor",  color: "#7E57C2" },
  { v: "wholesale",   label: "Mayorista",   color: "#FF7043" },
  { v: "distributor", label: "Distribuidor", color: "#0EA5E9" },
];

export const MONTHS_ES = ["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"];
export const monthLabel = (ym) => { const [y, m] = ym.split("-"); return `${MONTHS_ES[parseInt(m, 10) - 1]} ${y}`; };

export const fmtMoney = (v, cur) =>
  `${cur === "USD" ? "$" : "MX$"}${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export const fmtDate = (iso) => {
  try { const d = new Date(iso); return d.toLocaleDateString("es-MX", { day: "2-digit", month: "short" }); }
  catch { return ""; }
};
